// 블록 모드(V3) 챗에서만 보이는 빌더 탭. 사이드바·상단 탭바·블록 모드 끄기(ChatBuilder toggleBlockMode)가
// 같은 목록을 본다 — 예전엔 세 곳에 "block·submissions"를 따로 적어 두어 탭을 늘릴 때 한 곳씩 빠졌다.
export const V3_ONLY_TABS = ["conversation", "block", "submissions"];
